<template>
    <div>
        <h1 class="display-heading">Newsletter History</h1>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col width="250">
                    <col>
                    <col width="100">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Sent Date</th>
                            <th scope="col">Email Subject</th>
                            <th scope="col" class="text-right">Total Recipients</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="history.length === 0">
                            <td colspan="5" class="text-center font-italic">
                                No Data
                            </td>
                        </tr>
                        <tr v-for="(newsletter, index) in history" :key="index">
                            <td>
                                {{ index + 1 }}
                            </td>
                            <td>
                                {{ convertToUserReadableDateTime(newsletter.addedAt) }}
                            </td>
                            <td>
                                {{ newsletter.emailSubject }}
                            </td>
                            <td class="text-right">
                                {{ newsletter.recipientCount }}
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'newsletter-history-detail',
                                    'params': {'id': newsletter.newsletterEmailRequestId}
                                }">
                                View
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDateTime
} from '@/utilities';
export default {
    'name': 'NewsletterHistory',
    data () {
        return {
            'history': []
        };
    },
    mounted () {
        this.getList();
    },
    'methods': {
        convertToUserReadableDateTime,
        getList () {
            this.axios.get('Newsletter/SentList').then(({ data }) => {
                this.history = data.data;
            });
        }
    }
};
</script>
